import React from 'react'
import { navigate } from '@reach/router'
import { RouteProps } from '../../routes/AppRouter'
import { AssignTo } from '../../features/form-generator/AssignTo'
import { ROUTE_FORM_GENERATOR } from '../../routes/routes-constants'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

// La asignacion es ahora un modal que se abre desde el listado de
// cuestionarios. Esta ruta se mantiene para que los enlaces directos sigan
// funcionando: monta el mismo modal abierto y al cerrarlo vuelve al listado.
export function FormGeneratorAssignTo(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <AssignTo
      open
      formID={props.id || ''}
      onClose={() => {
        navigate(ROUTE_FORM_GENERATOR).then()
      }}
    />
  )
}
